export enum GeneralActionTypes {
  TOGGLE_SIDE = '@general/toggleSide'
}

export interface GeneralState {
  readonly collapsedSide: boolean
}
